import { render } from "./support-popup.vue?vue&type=template&id=b8ebc378"
import script from "./support-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./support-popup.vue?vue&type=script&setup=true&lang=js"

import "./support-popup.vue?vue&type=style&index=0&id=b8ebc378&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/support/support-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b8ebc378"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b8ebc378', __exports__)) {
    api.reload('b8ebc378', __exports__)
  }
  
  module.hot.accept("./support-popup.vue?vue&type=template&id=b8ebc378", () => {
    api.rerender('b8ebc378', render)
  })

}


export default __exports__